import { ApiError, isUserFacing, request } from '@/shared/api/client';
import { type BannerDto, splitBanners } from '@/shared/lib/banner';
import { couponImageSrc } from '@/shared/lib/image';
import type { Coupon, CouponResult } from './coupon';

type CouponDetailResponseDto = {
  productName: string;
  brandName: string;
  couponNumber: string;
  numberType: 'BARCODE' | 'URL';
  imageUrl: string | null;
  validEndDate: string;
  storeInformation: string[];
  precautions: string[];
  restrictions: string[];
  isChangecon: boolean;
  banners: BannerDto[];
};

function toCoupon(dto: CouponDetailResponseDto, seqnumber: string): Coupon {
  const { topBanners, bottomBanners } = splitBanners(dto.banners);
  return {
    image: dto.imageUrl ?? '',
    imageProxy: couponImageSrc(seqnumber),
    name: dto.productName,
    brand: dto.brandName,
    number: dto.couponNumber,
    precaution: dto.precautions,
    restriction: dto.restrictions,
    store: dto.storeInformation,
    expired: dto.validEndDate.replaceAll('-', '.'),
    topBanners,
    bottomBanners,
  };
}

export async function find(seqnumber: string): Promise<CouponResult> {
  try {
    const dto = await request<CouponDetailResponseDto>(`/coupons/${encodeURIComponent(seqnumber)}`);
    return { status: 'ok', coupon: toCoupon(dto, seqnumber) };
  } catch (error) {
    if (error instanceof ApiError && error.status >= 400) {
      const show = isUserFacing(error);
      return { status: 'error', message: show ? error.message : '', show };
    }
    throw error;
  }
}
